import { logger } from 'src/commons/utils/logger';
import { AjaxRequestPublisher } from 'src/commons/utils/metrics';
import {
  NETWORK_ERROR_REGEX,
  REQUEST_ERROR_REGEX,
  USER_ABORTED_REQUEST_ERROR,
} from './constants';

type HandleErrorProps = {
  error: Error;
  loggerMessage: string;
  metricSlug: string;
};

const logError = ({ error, loggerMessage, metricSlug }: HandleErrorProps) => {
  logger.error(loggerMessage);
  if (NETWORK_ERROR_REGEX.test(error.message)) {
    AjaxRequestPublisher.publishCounterMonitor(
      `${metricSlug}:networkFailure`,
      1,
    );
  } else if (REQUEST_ERROR_REGEX.test(error.message)) {
    AjaxRequestPublisher.publishCounterMonitor(
      `${metricSlug}:requestAborted`,
      1,
    );
  } else if (USER_ABORTED_REQUEST_ERROR.test(error.message)) {
    AjaxRequestPublisher.publishCounterMonitor(
      `${metricSlug}:userAbortedRequest`,
      1,
    );
  }
};

export default logError;
